export default import.meta.ROLLDOWN_FILE_URL_4EWke9T4eqQcsnhGx5FGww